module.exports = __webpack_public_path__ + "img/211.c7460fb2.jpg";